import { type FC } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";

import { Promotion } from "nvent-web-admin/types/Promotion";

import { BenefitIcon } from "../BenefitIcon/BenefitIcon";
import { Promotion as PromotionComponent } from "../Promotion/Promotion";

import styles from "./CertProBenefitsList.module.scss";

interface CertProBenefitsListProps {
  promotions: Promotion[];
  logoUrl: string;
  contactEmail: string;
  websiteUrl: string;
}

export const CertProBenefitsList: FC<CertProBenefitsListProps> = (props) => {
  const websiteHost = new URL(props.websiteUrl).host;

  return (
    <section className={styles.container}>
      <div className={styles.titleRow}>
        <BenefitIcon icon="TwentyYears" borderRadius="sm" className={styles.titleIcon} />

        <h3 className={styles.title}>
          <FormattedMessage id="certifiedPage.proBenefits.title" />
        </h3>
      </div>

      <p className={styles.lead}>
        <FormattedMessage id="certifiedPage.proBenefits.lead" />
      </p>

      <ul className={styles.cards}>
        <li className={styles.card}>
          <BenefitIcon icon="Certificate" borderRadius="sm" className={styles.cardIcon} />

          {props.logoUrl && (
            <p className={styles.cardContent}>
              <FormattedHTMLMessage
                id="certifiedPage.proBenefits.download"
                values={{
                  href: props.logoUrl,
                }}
              />
            </p>
          )}
        </li>

        <li className={styles.card}>
          <BenefitIcon icon="Website" borderRadius="sm" className={styles.cardIcon} />

          <p className={styles.cardContent}>
            <FormattedHTMLMessage
              id="certifiedPage.proBenefits.installer"
              values={{
                websiteHost,
                websiteUrl: props.websiteUrl,
                contactEmail: props.contactEmail,
              }}
            />
          </p>
        </li>

        <li className={styles.card}>
          <BenefitIcon icon="News" borderRadius="sm" className={styles.cardIcon} />

          <div className={styles.cardContent}>
            <p className={styles.cardHeading}>
              <FormattedMessage id="certifiedPage.proBenefits.news" />
            </p>

            {props.promotions.length === 0 ? (
              <FormattedMessage id="certifiedPage.certified.activePromotions.empty" />
            ) : (
              props.promotions.map((promotion) => <PromotionComponent promotion={promotion} key={promotion.id} />)
            )}
          </div>
        </li>

        <li className={styles.card}>
          <BenefitIcon icon="TwentyYears" borderRadius="sm" className={styles.cardIcon} />

          <div className={styles.cardContent}>
            <p className={styles.cardHeading}>
              <FormattedMessage id="certifiedPage.proBenefits.nutshell.title" />
            </p>
            <ul>
              <FormattedHTMLMessage id="certifiedPage.proBenefits.nutshell.list" />
            </ul>
          </div>
        </li>
      </ul>
    </section>
  );
};
